module.exports = __webpack_public_path__ + "img/clonbrowser_zh.7ac45a22.png";